import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const ContraEntryList = () => {
    const [contraEntries, setContraEntries] = useState([]);
    const [filteredContraEntries, setFilteredContraEntries] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch contra entries when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}contraentry`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    setContraEntries(data.data);
                    setFilteredContraEntries(data.data); // Set initial filtered contra entries
                }
            })
            .catch((error) => console.error('Error fetching contra entries:', error));
    }, []);

    // Handle search term change
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        // Filter contra entries based on the search term
        const filtered = contraEntries.filter((entry) =>
            entry.party_id.toString().includes(term) ||
            entry.dr_in_amount.toString().includes(term) ||
            entry.cr_in_amount.toString().includes(term)
        );
        setFilteredContraEntries(filtered);
    };

    // Navigate to the add contra entry page
    const handleAdd = () => {
        navigate('/AddContraEntry');
    };

    // Navigate to the edit contra entry page
    const handleEdit = (id) => {
        navigate(`/EditContraEntry/${id}`);
    };

    // Handle contra entry deletion
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this contra entry?")) {
            fetch(`${BASE_URL}contraentry/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.status === 1) {
                        // Remove the deleted contra entry from both lists (contraEntries and filteredContraEntries)
                        setContraEntries(contraEntries.filter((entry) => entry.id !== id));
                        setFilteredContraEntries(filteredContraEntries.filter((entry) => entry.id !== id));
                    }
                })
                .catch((error) => console.error('Error deleting contra entry:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Contra Entries List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Basic Tables start */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Contra Entry</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label htmlFor="searchTerm" className="form-label">Search by Party ID, Dr In Amount, or Cr In Amount</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search by party ID, Dr In Amount, or Cr In Amount"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>Party ID</th>
                                                <th>Dr In Amount</th>
                                                <th>Cr In Amount</th>
                                                <th>Created At</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredContraEntries.map((entry) => (
                                                <tr key={entry.id}>
                                                    <td>{entry.party_id || 'N/A'}</td>
                                                    <td>{entry.dr_in_amount || 'N/A'}</td>
                                                    <td>{entry.cr_in_amount || 'N/A'}</td>
                                                    <td>{new Date(entry.created_at).toLocaleString()}</td>
                                                    <td className="text-end">
                                                        <button
                                                            className="btn btn-primary me-2"
                                                            onClick={() => handleEdit(entry.id)}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button
                                                            className="btn btn-danger"
                                                            onClick={() => handleDelete(entry.id)}
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Basic Tables end */}
        </div>
    );
};

export default ContraEntryList;
